// Mappa area_enum (lowercase dal DB) -> metadata UI
export const AREE = {
  business: { label: 'Business', color: '#E5484D', textClass: 'text-area-business' },
  lavoro:    { label: 'Lavoro',   color: '#2563EB', textClass: 'text-area-lavoro' },
  personale: { label: 'Personale', color: '#F97316', textClass: 'text-area-personale' },
  salute:    { label: 'Salute',   color: '#475569', textClass: 'text-area-salute' },
};

export const AREE_ORDER = ['business', 'lavoro', 'personale', 'salute'];
